import { NavItemType } from '@/router/type'

const telemedicineRouterItems: NavItemType[] = [
  {
    id: 'appointment',
    title: 'Atendimento',
    icon: 'clipboard',
    type: 'collapse',
    pathname: '/atendimento',
    children: [
      {
        id: 'scheduleAppointment',
        title: 'Agendar consulta',
        url: '/atendimento/agendar/consulta',
        type: 'item',
      },
      {
        id: 'appointmentLogs',
        title: 'Log atendimentos',
        url: '/atendimento/atendimento-log',
        type: 'item',
      },
      {
        id: 'medicalRecord',
        title: 'Prontuário',
        url: '/atendimento/prontuario',
        type: 'item',
      },
      {
        id: 'communicationLogs',
        title: 'Logs de comunicação',
        url: '/atendimento/logs-comunicacao',
        type: 'item',
      },
      {
        id: 'appointmentQueue',
        title: 'Fila de atendimento',
        url: '/atendimento/fila-atendimento',
        type: 'item',
      },
      {
        id: 'historyAppointment',
        title: 'Histórico de agendamentos',
        url: '/atendimento/historico-atendimentos',
        type: 'item',
      },
      {
        id: 'medicalReferral',
        title: 'Liberação de plano de saúde',
        url: '/atendimento/liberacao-plano-saude',
        type: 'item',
      },
      {
        id: 'forwardingList',
        title: 'Lista de encaminhamentos',
        url: '/atendimento/lista-de-encaminhamentos',
        type: 'item',
      },
      {
        id: 'smartSearchAnalysis',
        title: 'Agenda Inteligente',
        url: '/atendimento/agenda-inteligente',
        type: 'item',
      },
      {
        id: 'outcomeChange',
        title: 'Alteração de desfecho',
        url: '/atendimento/alteracao-desfecho',
        type: 'item',
      },
      {
        id: 'recurrences',
        title: 'Recorrências',
        url: '/atendimento/recorrencias',
        type: 'item',
      },
      {
        id: 'professionalChange',
        title: 'Alterar Profissional Atendimento',
        url: '/atendimento/troca-profissional',
        type: 'item',
      },
    ],
  },
]

export default telemedicineRouterItems
